// Feeds Google Analytics 4 from a SPA: GA counts only the initial document
// load by itself, so each client-side navigation is reported explicitly.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFirebase } from './FirebaseContextProvider';
import { trackPageView, trackUser } from '../utils/analytics';

const AnalyticsObserver = () => {
  const { pathname, search } = useLocation();
  const { user } = useFirebase();

  useEffect(() => {
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);

  useEffect(() => {
    trackUser(user?.id ?? null, user ? { role: user.role } : undefined);
  }, [user?.id, user?.role]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default AnalyticsObserver;
